import Icon from "@client/controls/Icon/component";
import * as React from "react";

export interface PaginationMapProps {
  hasPrevious: boolean;
  hasNext: boolean;
}

export interface PaginationActionProps {
  onPreviousClick: () => void;
  onNextClick: () => void;
}
export type PaginationProps = PaginationActionProps & PaginationMapProps;

export default (props: PaginationProps) => (
  <div className="pages">
    {props.hasPrevious && <Icon iconClassName="far fa-chevron-left" onClick={props.onPreviousClick} />}
    {props.hasNext && <Icon iconClassName="far fa-chevron-right" onClick={props.onNextClick} />}
  </div>
);
